import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {InterfaceMode} from "@/store/player/types";
import Text = Phaser.GameObjects.Text;
import Sprite = Phaser.GameObjects.Sprite;
import {Positioner} from "@/utils/positioner";
import {PositionUtils} from "@/utils/position-utils";
import Graphics = Phaser.GameObjects.Graphics;
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export default class ExperiencePanel extends Phaser.GameObjects.Container {

    private currentLevelText!: Text;
    private expInner!: Sprite;
    private expOuter!: Sprite;
    private expCover!: Sprite;
    private maskShape!: Graphics;
    private outerBarHeight!: number;
    private onClickCallback!: () => unknown;

    private positioner!: Positioner;

    constructor(scene: Scene, canvas: HTMLCanvasElement, currentExp: number, maxExp: number, currentBarWidth: number,
                level: number, onClickCallback: () => unknown, mode: InterfaceMode | undefined) {
        super(scene);

        this.positioner = PositionUtils.getPositioner();

        this.scene = scene;

        this.setDepth(1000);

        let x = mode === InterfaceMode.MODERN ? CU.shiftLeft(53) : CU.shiftLeft(60);
        let y = mode === InterfaceMode.MODERN ? CU.shiftTop(41 + this.positioner.getButtonsTopY()) : CU.shiftBottom(canvas, 95);

        this.onClickCallback = onClickCallback;

        this.expInner = SpriteUtils.addSpriteN(this.scene, x, y, Keys.ATLAS_UI_2, Keys.UI2_EXP_BACK);
        this.expOuter = SpriteUtils.addSpriteN(this.scene, this.expInner.x, this.expInner.y, Keys.ATLAS_UI_2, Keys.UI2_EXP_INNER);
        this.expCover = SpriteUtils.addSpriteN(this.scene, this.expInner.x, this.expInner.y, Keys.ATLAS_UI_2, Keys.UI2_EXP_GLASS);

        this.outerBarHeight = this.expOuter.height / 2;

        this.maskShape = this.scene.make.graphics({}, false);
        this.maskShape.fillRect(this.expOuter.getTopLeft().x!, 0, this.expOuter.width * CU.S, this.expOuter.height * CU.S);
        this.maskShape.setVisible(false);

        this.expOuter.mask = new Phaser.Display.Masks.GeometryMask(this.scene, this.maskShape);

        this.currentLevelText = TextUtils.addText(scene, Tr('ur.dot') + level, this.expInner.x / CU.S, this.expInner.y / CU.S, '#ffffff',
            11, 'normal', 50);

        this.add([this.expInner, this.expOuter, this.maskShape, this.expCover, this.currentLevelText]);

        this.setExpFillerLine(currentBarWidth);
        this.setInteractions();
    }

    public setExpFillerLine(scale: number) {
        let y = this.expOuter.getTopLeft().y! + this.expOuter.height * 0.87 * (1 - scale) * CU.S;
        this.maskShape.setY(y);
    }

    public updateValuesText(currentValue: number, endValue: number, level: number) {
        if (this.currentLevelText && this.currentLevelText.active) {
            this.currentLevelText.setText(Tr('ur.dot') + level);
        }
    }

    public changeChildrenPosition(y: number) {
        this.expInner.y -= y;
        this.expOuter.y -= y;
        this.expCover.y -= y;
        this.maskShape.y -= y;
        this.currentLevelText.y -= y;
    }

    private setInteractions() {
        this.expInner.setInteractive().on('pointerup', () => {
            if (this.onClickCallback != null) {
                this.onClickCallback();
            }
        });
    }

}
